export default [{
  path: '/tipo-tributacao',
  component: {
    name: 'tipoTributacaoBase',
    template: '<router-view />',
    meta: {
      resource: 'tributacao',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'tributacoes',
    component: () => import('@/app-modulo/comercial/tipo-tributacao/TipoTributacaoView.vue'),
    meta: {
      resource: 'tributacao',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'tributacoes',
      pageTitle: 'Tipos de tributação',
      breadcrumb: [
        {
          text: 'Tipos de tributação',
          to: { name: 'tributacoes' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-tipo-tributacao',
    component: () => import('@/app-modulo/comercial/tipo-tributacao/shared/components/cadastro/TipoTributacao.vue'),
    meta: {
      resource: 'tributacao',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'tributacoes',
      pageTitle: 'Cadastro de tributação',
      breadcrumb: [
        {
          text: 'Tipos de tributação',
          to: { name: 'tributacoes' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-tipo-tributacao' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-tipo-tributacao',
    component: () => import('@/app-modulo/comercial/tipo-tributacao/shared/components/cadastro/TipoTributacao.vue'),
    meta: {
      resource: 'tributacao',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'tributacoes',
      pageTitle: 'Cadastro de tributação',
      breadcrumb: [
        {
          text: 'Tipos de tributação',
          to: { name: 'tributacoes' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-tipo-tributacao' },
          active: true,
        },
      ],
    },
  }],
},
]
